import angular from 'angular';

import lineGraphComponent from './line.component';

export default angular.module('dbm.dashboard.components.graph.line', [])
.component('dbmLineGraph', lineGraphComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/line/index.js